(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-accordion"] && !Shopify.designMode) return;
  try {
    function initFaqToggle(container) {
    var scope = container || document;
    var faqblocks = scope.querySelectorAll('.faq-collapsible .faq-item .faq-question');

    // clear old listeners
    faqblocks.forEach(function (question) {
      question.replaceWith(question.cloneNode(true));
    });

    // reselect after clone
    faqblocks = scope.querySelectorAll('.faq-collapsible .faq-item .faq-question');

    faqblocks.forEach(function (question) {
      question.addEventListener('click', function () {
        var parent = this.parentElement;
        parent.classList.toggle('active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFaqToggle(document);
  });

  document.addEventListener('shopify:block:load', function (e) {
    initFaqToggle(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    initFaqToggle(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    initFaqToggle(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    initFaqToggle(e.target);
  });
  } catch(e) { console.error(e); }
})();

})();
